import React, { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import { sidebar } from "../routes/Sidebar";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
// import Logo from '../css/laptopA.png';
import LogoutIcon from "@mui/icons-material/Logout";
import ModalBox from "../components/modal/ModalBox";
import SubMenu from "./SubMenu";
import CountBadge from "../components/CountBadge/CountBadge";
import { fetchConsultantRequestCountApi } from "../services/consultantManagement";
import { toastMessage } from "../utils/toastMessage";
import { useDispatch, useSelector } from "react-redux";
import { setRightsInfo, setRole } from "../utils/store/slices/rightsSlice";
import useResponsive from "../hooks/useResponsive";

const Sidebar = ({ isOpen, onClose }) => {
  const [logoutModal, setLogoutModal] = useState(false);
  const { rightsInfo, role } = useSelector((state) => state?.vedicRights);
  const navigate = useNavigate();
  const location = useLocation();


  const menuCounts = {
    'Cancelled Consultation': 0,
    'Waitlist Management': 0,
    'Missed Chat/Call': 0,
    'Progress Chat/Call': 0,
    'Completed Chat/Call': 0,
    'Support Management': 0,
    'Booked Session-Waitlist': 0
  }

  const markAsRead = async (entryIds = null, type = null) => {
    console.log('markAsRead', entryIds, type);
  }

  const trackMenuClick = async (menuItem) => {
    console.log('trackMenuClick', menuItem);
  }

  function logoutHandler() {
    navigate("/");
    localStorage.removeItem("vedic_token");
    localStorage.removeItem("vedic_email");
    localStorage.removeItem("vedic_role");
    localStorage.removeItem("vedic_rights");
  }

  const { isMobile } = useResponsive();

  // Handle menu click tracking
  const handleMenuClick = async (menuName) => {
    try {
      await trackMenuClick(menuName);
    } catch (error) {
      console.error('Error tracking menu click:', error);
    }
  };



  return (
    <>
      {/* Mobile Overlay */}
      {isMobile && isOpen && (
        <div className="sidebar-overlay" onClick={onClose}></div>
      )}

      <div className={`SidenavArea ${isMobile ? (isOpen ? 'mobile-open' : 'mobile-closed') : ''}`}>
        <Accordion defaultActiveKey="0">
          <div className="SidenavContent">
            <div className="SidenavHead">
              <h2 style={{ fontWeight: "900" }}>Vedic Meet</h2>
              {isMobile && (
                <button className="close-sidebar-btn" onClick={onClose}>
                  ×
                </button>
              )}
            </div>

            <div className="SidenavBody">
              <ul>
                {sidebar(rightsInfo, role).map(
                  ({ path, icon, name, isChild }, index) =>
                    isChild ? (
                      <SubMenu
                        isChild={isChild}
                        icon={icon}
                        path={path}
                        name={name}
                        key={path}
                        onNavigate={isMobile ? onClose : undefined}
                      />
                    ) : (
                      <li
                        className={location.pathname === path ? "active" : ""}
                        key={path}
                      >
                        <NavLink
                          to={path}
                          onClick={() => {
                            if (isMobile) onClose();
                            handleMenuClick(name);
                              markAsRead(null, name); // Mark as read with correct type
                          }}
                          style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span>{icon}</span>
                            {name}
                          </div>
                          <CountBadge 
                            count={menuCounts[name] || 0}
                            variant="auto"
                            size="sm"
                          />
                        </NavLink>
                      </li>
                    )
                )}
                <li
                  className={"active"}
                >
                  <NavLink to="#" onClick={() => setLogoutModal(true)}>
                    <span className="mx-1">
                      <LogoutIcon fontSize="small" />
                    </span>
                    Logout
                  </NavLink>
                </li>
              </ul>
            </div>

           
          </div>
        </Accordion>
      </div>

      <ModalBox
        status={logoutModal}
        onClose={() => setLogoutModal(false)}
        title={"Logout"}
        description={"Are you sure want to logout?"}
        action={logoutHandler}
      />
    </>
  );

};

export default Sidebar;
